import { fetch, buildUrl } from 'domain/Api';
import { ApiCall, createApiActionCreator } from 'omni-common-ui';

export const FETCH_SINGLE_STUDENT_NOTE_REQUEST = 'FETCH_SINGLE_STUDENT_NOTE_REQUEST';
export const FETCH_SINGLE_STUDENT_NOTE_SUCCESS = 'FETCH_SINGLE_STUDENT_NOTE_SUCCESS';
export const FETCH_SINGLE_STUDENT_NOTE_FAILURE = 'FETCH_SINGLE_STUDENT_NOTE_FAILURE';
export const FETCH_STUDENT_NOTES_REQUEST = 'FETCH_STUDENT_NOTES_REQUEST';
export const FETCH_STUDENT_NOTES_SUCCESS = 'FETCH_STUDENT_NOTES_SUCCESS';
export const FETCH_STUDENT_NOTES_FAILURE = 'FETCH_STUDENT_NOTES_FAILURE';
export const SUBMIT_STUDENT_NOTE_REQUEST = 'SUBMIT_STUDENT_NOTE_REQUEST';
export const SUBMIT_STUDENT_NOTE_SUCCESS = 'SUBMIT_STUDENT_NOTE_SUCCESS';
export const SUBMIT_STUDENT_NOTE_FAILURE = 'SUBMIT_STUDENT_NOTE_FAILURE';

export const STUDENT_NOTE_CATEGORY_ATTENDANCE = 'attendance';
export const STUDENT_NOTE_CATEGORY_PROGRESS_TEST = 'progressTest';

/* --- */

const DISABLE_DEFAULT_ACTION_EXTRAS = { disableDefault: true };

const buildSingleStudentNoteUrl = (noteId) => buildUrl(`/notes/${noteId}`);

export function getApiCallState(state, noteId) {
  return ApiCall.find(state, { method: 'GET', url: buildSingleStudentNoteUrl(noteId) });
}

export function fetchSingleStudentNoteIfNeeded(noteId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, {
      method: 'GET',
      url: buildSingleStudentNoteUrl(noteId),
    })) {
      return false;
    }
    return dispatch(fetchSingleStudentNote(noteId));
  };
}

const createFetchSingleStudentNoteActionCreators =
    createApiActionCreator('SINGLE_STUDENT_NOTE');

export function fetchSingleStudentNote(noteId) {
  const url = buildSingleStudentNoteUrl(noteId);
  return createFetchSingleStudentNoteActionCreators(url, 'GET',
      // `disableDefault` in request, success, failure
      DISABLE_DEFAULT_ACTION_EXTRAS, DISABLE_DEFAULT_ACTION_EXTRAS, DISABLE_DEFAULT_ACTION_EXTRAS);
}

/* --- */

const buildStudentNotesUrl = (studentId) => buildUrl(`/students/${studentId}/notes`);

export function fetchStudentNotesIfNeeded(studentId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, {
      method: 'GET',
      url: buildStudentNotesUrl(studentId),
    })) {
      return false;
    }
    return dispatch(fetchStudentNotes(studentId));
  };
}

export function fetchStudentNotes(studentId) {
  return (dispatch) => {
    const url = buildStudentNotesUrl(studentId);
    const method = 'GET';

    return dispatch(fetchStudentNotesRequest()).payload
      .then((response) => dispatch(fetchStudentNotesSuccess(response)))
      .catch((error) => dispatch(fetchStudentNotesFailure(error)));

    function fetchStudentNotesRequest() {
      return ApiCall.createAction({
        type: FETCH_STUDENT_NOTES_REQUEST,
        payload: fetch(url),
        url,
        method,
        studentId,
        disableDefault: true,
      });
    }

    function fetchStudentNotesSuccess(notes) {
      return ApiCall.createAction({
        type: FETCH_STUDENT_NOTES_SUCCESS,
        payload: notes,
        url,
        method,
        studentId,
      });
    }

    function fetchStudentNotesFailure(error) {
      return ApiCall.createAction({
        type: FETCH_STUDENT_NOTES_FAILURE,
        error,
        url,
        method,
        studentId,
      });
    }
  };
}

export function submitStudentNote(studentId, model) {
  return (dispatch) => {
    const url = buildUrl(`/students/${studentId}/notes`);
    const method = 'POST';
    return dispatch(submitStudentNoteRequest()).payload
      .then((response) => dispatch(submitStudentNoteSuccess(response)))
      .catch((error) => dispatch(submitStudentNoteFailure(error)))
      .then(() => dispatch(fetchStudentNotes(studentId)));

    function submitStudentNoteRequest() {
      const request = fetch(url,
        {
          method,
          body: JSON.stringify(model),
        }
      );
      return ApiCall.createAction({
        type: SUBMIT_STUDENT_NOTE_REQUEST,
        payload: request,
        url,
        method,
        studentId,
        model,
      });
    }

    function submitStudentNoteSuccess() {
      return ApiCall.createAction({
        type: SUBMIT_STUDENT_NOTE_SUCCESS,
        url,
        method,
      });
    }

    function submitStudentNoteFailure(error) {
      return ApiCall.createAction({
        type: SUBMIT_STUDENT_NOTE_FAILURE,
        url,
        method,
        error,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./containers/Student/Note/actions.js